import UnassignAvailabilityListTableComponent from "./unassignAvailabilityListTable.component";

export default function UnassignAvaliabilityListTableContainer({
    validatedItems,
    onDeleteItem,
    isUpdating,
    selectedMethod,
}) {
    return (
        <UnassignAvailabilityListTableComponent
          validatedItems={validatedItems}
          onDeleteItem={onDeleteItem}
          isUpdating={isUpdating}
          selectedMethod={selectedMethod}
        />
    );
}
